var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Chart',{attrs:{"chartData":_vm.computedData,"options":_vm.computedOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }